/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import React, { Component } from "react";

// components - atoms
import Button from "components/atoms/Button/Button.js";
import SVG from "components/atoms/SVG/SVG.js";

// svgs
import SVG_X from "svgs/SVG_X.js";

// const
const CLASSNAME = "col-xl m-1";
const CLASSNAME_FADING = `${CLASSNAME} kit-animation-fade-out`;

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hide: false,
      isFading: false
    };
  }

  render() {
    const { props, state } = this;
    const { message, type } = props;
    const { hide, isFading } = state;
    const className = isFading ? CLASSNAME_FADING : CLASSNAME;
    const finalClassName = hide ? "d-none" : className;

    return (
      <div className={finalClassName} style={{ pointerEvents: "all" }}>
        <div className={`bg-${type} p-1 rounded kit-border-shadow`}>
          <ul className={"bg-white list-group"}>
            <li className={"d-flex list-group-item"}>
              {message}
              <Button
                className={"align-items-center btn btn-light d-flex justify-content-center ml-auto px-1 py-0"}
                onClick={() => this.setState({ hide: true })}
              >
                <SVG>{SVG_X}</SVG>
              </Button>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  componentDidMount() {
    const { props } = this;
    const { duration } = props;
    setTimeout(() => {
      this.setState({ isFading: true });
    }, duration);
  }

}
export default Notification;
